var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-xmark 1",
    clipPath: "url(#clip0_21359_39246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_b_21359_39246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0479 20.8828C15.5713 20.8828 20.0479 16.4062 20.0479 10.8828C20.0479 5.35938 15.5713 0.882812 10.0479 0.882812C4.52441 0.882812 0.0478516 5.35938 0.0478516 10.8828C0.0478516 16.4062 4.52441 20.8828 10.0479 20.8828ZM6.88379 7.71875C7.25098 7.35156 7.84473 7.35156 8.20801 7.71875L10.0439 9.55469L11.8799 7.71875C12.2471 7.35156 12.8408 7.35156 13.2041 7.71875C13.5674 8.08594 13.5713 8.67969 13.2041 9.04297L11.3682 10.8789L13.2041 12.7148C13.5713 13.082 13.5713 13.6758 13.2041 14.0391C12.8369 14.4023 12.2432 14.4062 11.8799 14.0391L10.0439 12.2031L8.20801 14.0391C7.84082 14.4062 7.24707 14.4062 6.88379 14.0391C6.52051 13.6719 6.5166 13.0781 6.88379 12.7148L8.71973 10.8789L6.88379 9.04297C6.5166 8.67578 6.5166 8.08203 6.88379 7.71875Z",
    fill: "black",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21359_39246",
    x: -13.9521,
    y: -13.1172,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21359_39246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21359_39246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21359_39246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0478516 0.882812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmark);
export default __webpack_public_path__ + "static/media/circleXmark.c382968ce60f8447bd24d7df43c71062.svg";
export { ForwardRef as ReactComponent };